<div ngbDropdown class="help" tabindex="5">
  <button class="btn icon-help" ngbDropdownToggle>
      <!-- <i class="icon-help"></i> -->
  </button>
  <div ngbDropdownMenu aria-labelledby="helpinfo">
      <div class="pointer"></div>
      <button class="dropdown-item" (click)="openTourPopUp()"><span class="help-icon iconB-guide-tour"></span> Tour Guide<i ngbTooltip="Tour guide"></i></button>
      <button class="dropdown-item" (click)=" $event.preventDefault(); $event.stopPropagation();openHelpInfo() "><span class="help-icon iconB-doc i"></span> Help Doc<i ngbTooltip="Help"></i></button>
      <button class="dropdown-item" (click)="onClickReleaseHistory()"><span class="help-icon iconB-release-history"></span> Release History</button>
      <button class="dropdown-item" (click)="openLink()"><span class="help-icon iconB-guide-tour"></span> Community Forum <sup>Beta</sup></button>
      <button class="dropdown-item disabled">{{releaseVersion}} </button>
      
 
  </div>

</div>


<!-- <app-info-icon *ngIf="helpdocStatus" [autoTrigger]="true" (close)="a();helpdocStatus=false"></app-info-icon> -->